<template>
  <v-container grid-list-md fluid>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 sm8>
        <v-btn color="primary" @click="refreshEmpresas(2)" class="mb-4">
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-layout justify-space-between align-left>
          <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
          <v-checkbox label="Apenas Ativos" v-model="apenasAtivos" @change="filtrarItens" />
        </v-layout>
      </v-flex>

      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.user ? props.item.user.name : "" }}</td>
            <td>{{ props.item.acesso ? props.item.acesso.id_texto : "" }}</td>
            <td>
              <v-checkbox
                v-model="props.item.ativo"
                color="primary"
                @click.native="editValue(entity, props.item.id, props.item)"
              ></v-checkbox>
            </td>
            <td align="center">
              <v-btn
                icon
                class="mx-0"
                @click="refreshEmpresas(3, props.item)"
                :disabled="!hasCondominioAccess(entity, 'update')"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="deleteItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'delete')"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">{{ formTitle }}</span>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  name="user_id"
                  :label="translate('table.' + entity + '.field.user_id')"
                  v-model="editedItem.user_id"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('user_id')"
                  :data-vv-as="translate('table.' + entity + '.field.user_id')"
                  :items="dynamicUsers"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  name="acesso_id"
                  :label="translate('table.' + entity + '.field.acesso_id')"
                  v-model="editedItem.acesso_id"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('acesso_id')"
                  :data-vv-as="translate('table.' + entity + '.field.acesso_id')"
                  :items="acessos"
                  item-text="id_texto"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-switch
                  color="primary"
                  :label="translate('table.' + entity + '.field.ativo')"
                  v-model="editedItem.ativo"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}
</style>

<script>
import crud from "./../../mixin/crud";
import acl from "./../../mixin/acl";

export default {
  mixins: [crud, acl],
  data: () => ({
    entity: "condominio_users",
    items: [],
    dynamicUsers: [],
    apenasAtivos: true,
    // acessos: []
  }),
  name: "Usuario",
  props: ["condominio_id", "values", "users", "acessos"],
  created() {
    this.items = this.values;
    this.editedItem = { ativo: true, user_id: "", condominio_id: this.condominio_id };
    this.defaultItem = { ativo: true, user_id: "", condominio_id: this.condominio_id };
    // this.acessos = this.access
    this.itensOriginais = [...this.items];
    this.filtrarItens();
  },
  methods: {
    filtrarItens() {
      if (this.apenasAtivos) {
        this.items = this.items.filter((item) => item.ativo);
      } else {
        this.items = this.itensOriginais;
      }
    },
    refreshEmpresas(tela, obj = {}) {
      let remove;
      switch (tela) {
        case 2:
          this.create();
          remove = this.items.map((a) => a.user_id);
          break;
        case 3: {
          this.editItem(obj);
          remove = this.items.map((a) => {
            if (a.user_id !== this.editedItem.user_id) {
              return a.user_id;
            }
          });
          break;
        }
      }
      this.dynamicUsers = this.users.filter((item) => !remove.includes(item.id));
    },
  },
  computed: {
    headers: function () {
      return [
        { text: this.translate("table." + this.entity + ".field.user_id"), value: "user_id" },
        { text: this.translate("table." + this.entity + ".field.acesso_id"), value: "acesso_id" },
        { text: this.translate("table." + this.entity + ".field.ativo"), value: "ativo" },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/details/Usuario.vue